import * as TYPES from "./types";
import actionsWizard from './actions';
import gettersWizard from './getters';
import mutationsWizard from './mutations';
import routes from '../../router/wizard';

export const getInitialSpecs = () => ({
    voltage: null,
    rmsVoltage: null,
    acCurrent: null,
    dcCurrent: null,
    acPower: null,
    dcPower: null,
    frequency: null
});

export const getInitialConsult = () => ({
    applications: [],
    currentType: null,
    setpoint: null,
    ...getInitialSpecs()
});

export const state = {
    catalog: null,
    consult_id: null,
    loading: false,
    ui: {
        showSteps: true,
        steps: routes,
        currentStepIndex: 0,
        maxStepIndex: 0
    },
    consult: getInitialConsult(),
    products: [],
};

export const getters = {...gettersWizard};
export const mutations = {...mutationsWizard};
export const actions = {...actionsWizard};
